import React from 'react';
import { DateTimeFormat } from '../../../config';
import { format } from 'date-fns';

export function TrackTableDateCell(text: string): JSX.Element {
  return <React.Fragment>{format(new Date(text || new Date()), DateTimeFormat)}</React.Fragment>;
}
